import { IconsContext, IIconsContext } from "@/contexts";
import { useContext } from "react";

export function useIcons(): IIconsContext {
  const context = useContext(IconsContext);

  if (!context) {
    throw new Error("useIcons must be used within an IconsProvider");
  }

  return context;
}
